import ActionTypes from "../../enums/ActionTypes"
import { API_SERVER_USER } from "../../constants/api"
import rolesSchema from "../../schemas/dashboard/roles"
import { APIRequestSequence } from "../api"

export default [
  APIRequestSequence({
    actionType: ActionTypes.DASHBOARD_ROLES_LIST,
    endPoint: `${API_SERVER_USER}/dashboardroles`,
    schema: rolesSchema,
  }),
]
